import React, { useState } from 'react';
import HomeBanner from '../components/HomeBanner';
import FeaturedProductsCarousel from '../components/FeaturedProductsCarousel';
import CategoriesCarousel from '../components/CategoriesCarousel';
import ShopProductGrid from '../components/ShopProductGrid';
import SocialMediaVideos from '../components/SocialMediaVideos';
import ProductDetailModal from '../components/ProductDetailModal';
import { motion } from "framer-motion";
import SocialMediaGallery from "../components/SocialMediaGallery";
import BenefitsSection from "../components/BenefitsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import StepsSection from "../components/StepsSection";
import BigCTASection from "../components/BigCTASection";
import LocationSection from "../components/LocationSection";
import AboutUsSection from "../components/AboutUsSection";

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
};

const HomePage = ({ onAddToCart, onNavigate, bannerVideos, bannerText, bannerLoaded }) => {
  // ...
      const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleViewDetail = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  return (
<div className="bg-gray-50 min-h-screen">
  {bannerLoaded ? (
    <HomeBanner
      videos={bannerVideos}
      bannerText={bannerText}
      onGoToShop={() => onNavigate("shop")}
    />
  ) : (
    <div className="h-72 sm:h-96 md:h-[480px] lg:h-[600px] bg-gray-100 flex items-center justify-center">
      {/* Loader opcional */}
      {/* <Spinner /> */}
    </div>
  )}

  {/* ...resto de tu página... */}


      {/* Carrusel de categorías */}
<CategoriesCarousel onSelectCategory={(catName) => {
  onNavigate('shop');
  // Si manejas el filtro, podrías llamar también a una función para guardar la categoría seleccionada.
  // Por ejemplo: setSelectedCategory(catName);
}} />
<AboutUsSection onNavigate={onNavigate} />

<BenefitsSection />

      {/* Carrusel de productos destacados */}
      <FeaturedProductsCarousel
        onAddToCart={onAddToCart}
        onViewDetail={handleViewDetail}
      />


<SocialMediaGallery />
<TestimonialsSection />
<StepsSection />
<BigCTASection />
      {/* Galería social/Instagram */}
      <SocialMediaVideos />
<LocationSection />
      {/* Productos normales (solo imágenes, grid compacto, con click para ir a la tienda) */}
      {/* Aquí podrías hacer otro grid con solo imágenes, o reutilizar ShopProductGrid con props especiales */}

      {/* MODAL DE DETALLES */}
      <ProductDetailModal
        product={selectedProduct}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onAddToCart={onAddToCart}
      />
    </div>
  );
};

export default HomePage;
